const Ring = () => <div className="lds-dual-ring" />;

export default Ring;
